import React from "react";
import { formatCurrency } from "../../../utils/currency";
import { formatUTCDate } from "./../../../utils/string";
import { AccountSummaryData } from "../../../AccountSummary.slice";
import { useAppSelector } from "../../../store/hooks";
import { useAutopayNextCycle } from "./useAutopayNextCycle";
import { useResolvedAutopayPaymentMethod } from "./useAutopayPaymentMethodDisplay";
import { PaymentMethodSourceLabel } from "../../PaymentMethods/components/PaymentMethodSourceLabel";
import { isDelegateAutopayAccount } from "./setAutopayPaymentMethod";

interface PropsInterface {
  paymentMethodId?: string;
  account?: AccountSummaryData;
}

export const AutoPayDebitDetails: React.FC<PropsInterface> = (props) => {
  const { paymentMethodId, account } = props;
  const accountSummary = useAppSelector((state) => state.accountSummary);
  const { data, activeTenantAccountIndex } = accountSummary;
  const accountSummaryData = account ?? data?.[activeTenantAccountIndex];
  const isDelegateAutopay = accountSummaryData
    ? isDelegateAutopayAccount(accountSummaryData)
    : false;
  const paymentMethod = useResolvedAutopayPaymentMethod(paymentMethodId);
  const { hasUpcomingDebit, debitAmount, runDate } =
    useAutopayNextCycle(accountSummaryData);

  return (
    <>
      {hasUpcomingDebit && (
        <>
          <strong>{formatCurrency(debitAmount)}</strong> on or around{" "}
          <strong>{formatUTCDate(runDate)}</strong>
        </>
      )}

      {isDelegateAutopay ? (
        <> from a delegate user&apos;s payment method</>
      ) : (
        <>
          {" "}
          from your AutoPay payment method:{" "}
          {paymentMethod ? (
            <PaymentMethodSourceLabel paymentMethod={paymentMethod} />
          ) : (
            <strong>Payment method unavailable</strong>
          )}
        </>
      )}
    </>
  );
};
